// extracted by mini-css-extract-plugin
module.exports = {"connect":"connect_connect__2BSea","connectOptions":"connect_connectOptions__fh3eH"};